import { Route, RouteType } from 'module/Model/Routes';

export namespace RouterUtils {
  export function extractKey(route: Route | null): string {
    if (route === null) {
      return 'null';
    }
    if (route.type === RouteType.Home || route.type === RouteType.Category) {
      return 'post-lists';
    }
    return route.type + '-' + route.id;
  }
}



// WEBPACK FOOTER //
// ./src/module/Common/utils/RouterUtils.ts